// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CriteriaDetailsBase, CriteriaDetailsBaseSchema } from 'api/gen/CriteriaDetailsBase';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { DateCriteriaValues, DateCriteriaValuesSchema } from 'api/gen/DateCriteriaValues';

const requiredPart = t.interface({
  tag: t.literal('DATE'),
  values: DateCriteriaValuesSchema,
});

export const DateCriteriaDetailsSchema = excess(t.intersection([CriteriaDetailsBaseSchema.type, requiredPart]));

export interface DateCriteriaDetails extends t.TypeOf<typeof DateCriteriaDetailsSchema> {}
